import React from "react";

const SuccessIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 1.75C5.89137 1.75 1.75 5.89137 1.75 11C1.75 16.1086 5.89137 20.25 11 20.25C16.1086 20.25 20.25 16.1086 20.25 11C20.25 5.89137 16.1086 1.75 11 1.75ZM0.25 11C0.25 5.06294 5.06294 0.25 11 0.25C16.9371 0.25 21.75 5.06294 21.75 11C21.75 16.9371 16.9371 21.75 11 21.75C5.06294 21.75 0.25 16.9371 0.25 11ZM16.0303 7.46967C16.3232 7.76256 16.3232 8.23744 16.0303 8.53033L10.0303 14.5303C9.73744 14.8232 9.26256 14.8232 8.96967 14.5303L5.96967 11.5303C5.67678 11.2374 5.67678 10.7626 5.96967 10.4697C6.26256 10.1768 6.73744 10.1768 7.03033 10.4697L9.5 12.9393L14.9697 7.46967C15.2626 7.17678 15.7374 7.17678 16.0303 7.46967Z"
        fill="white"
      />
    </svg>
  );
};

export default SuccessIcon;
